import { httpClient } from 'utils/httpClient';
import { apiErrorHandler } from 'utils/apis/helpers';

const base = '/marketplace';

export const getMarketplaceCatalog = () =>
  httpClient
    .get(`${base}/catalog`)
    .then(r => r.data)
    .catch(apiErrorHandler);

export const getMarketplaceSubscriptions = hostId =>
  httpClient
    .get(`${base}/subscriptions`, { params: { hostId } })
    .then(r => r.data)
    .catch(apiErrorHandler);

export const getMyMarketplaceSubscriptions = (params = {}) =>
  httpClient
    .get(`${base}/my-subscriptions`, { params })
    .then(r => r.data)
    .catch(apiErrorHandler);

export const getAdminMarketplaceSubscriptions = (params = {}) =>
  httpClient
    .get(`${base}/admin/subscriptions`, { params })
    .then(r => r.data)
    .catch(apiErrorHandler);

export const subscribeMarketplaceProduct = payload =>
  httpClient
    .post(`${base}/subscribe`, payload)
    .then(r => r.data)
    .catch(apiErrorHandler);

export const unsubscribeMarketplaceProduct = payload =>
  httpClient
    .post(`${base}/unsubscribe`, payload)
    .then(r => r.data)
    .catch(apiErrorHandler);

export const updateMarketplaceSubscriptionConfig = payload =>
  httpClient
    .patch(`${base}/subscription/config`, payload)
    .then(r => r.data)
    .catch(apiErrorHandler);

export const getMarketplaceContributions = ({ page, hostId }) =>
  httpClient
    .get(`${base}/contributions`, { params: { page, hostId } })
    .then(r => r.data)
    .catch(apiErrorHandler);

export const getMarketplacePages = hostId =>
  httpClient
    .get(`${base}/pages`, { params: { hostId } })
    .then(r => r.data)
    .catch(apiErrorHandler);
